import { ArgsType, Field } from '@nestjs/graphql'
import { BaseAddPictureDto } from '../base/baseAddPicture.dto'

@ArgsType()
export class ArcConvertFileDto extends BaseAddPictureDto {
  // Both ignored when they come from a request: generate-file converts the book's own file. Only add-file's own call,
  // for an upload it has not saved yet, names the source here [sc-28919].
  @Field()
  sourceFilePath!: string

  @Field()
  convertIntoFileExt!: string

  @Field()
  convertFromLocalFile?: boolean
}
